import React, { useMemo } from "react";
import { reduxForm } from "redux-form";
import { CircularProgress } from "@mui/material";

import { Strings } from "../../../../../../../dataProvider/localize";
import commonStyles from "../../../../../SwmsMasters/SwmsMastersStyle.module.css";
import styles from "../pre-start/JobSwmsFormV3PreStart.module.css";
import JobSwmsV3RescueReadinessQuestionsList from "./JobSwmsV3RescueReadinessQuestionsList";

const getVisibleOrders = (questions = []) => {
  let activeOrder = 0;

  return questions.map((question = {}) => {
    if (question.active) {
      activeOrder += 1;
      return activeOrder;
    }

    return "-";
  });
};

const getHeadingText = (headingContents) => {
  if (typeof headingContents === "string" || typeof headingContents === "number") {
    return `${headingContents}`;
  }

  if (!headingContents || typeof headingContents !== "object") {
    return "";
  }

  const candidates = ["content", "html", "heading", "text", "value"];
  const candidate = candidates.find((key) => (
    typeof headingContents[key] === "string" || typeof headingContents[key] === "number"
  ));

  return candidate ? `${headingContents[candidate]}` : "";
};

export { getHeadingText };
export function JobSwmsV3RescueReadinessContainer({
  serverState = {},
  onRetry = () => {},
  included = true,
  toggle = true,
  onOpenAddQuestion,
  onAddQuestion,
  onOpenEditQuestion,
  onEditQuestion,
  moveQuestionRow = () => {},
  onAfterDropQuestionRow = () => {},
  onCancelQuestions,
  onCancel = () => {},
  onSaveQuestions,
  onSave = () => {},
  hasUnsavedQuestionChanges = false,
  questionInteractionDisabled = false,
  requestInFlight = false,
}) {
  const questions = useMemo(() => {
    if (Array.isArray(serverState.questions)) {
      return serverState.questions;
    }

    return Array.isArray(serverState.data) ? serverState.data : [];
  }, [serverState.questions, serverState.data]);
  const visibleOrders = useMemo(() => getVisibleOrders(questions), [questions]);
  const isIncluded = included && toggle;
  const addQuestion = onOpenAddQuestion || onAddQuestion || (() => {});
  const editQuestion = onOpenEditQuestion || onEditQuestion || (() => {});
  const cancel = onCancelQuestions || onCancel;
  const save = onSaveQuestions || onSave;
  const error = serverState.error;
  return (
    <div className={styles.PreStartContainer}>
      <div className={styles.PreStartHeaderRow}>
        <div>
          <div className={styles.PreStartTitle}>Emergency Readiness</div>
          <div className={styles.PreStartSubtitle}>Manage the emergency readiness questions for this SWMS.</div>
        </div>
        <div className={styles.PreStartActionButtons}>
          <button className={commonStyles.PrimaryButton} type="button" onClick={addQuestion} disabled={questionInteractionDisabled}>
            Add Question
          </button>
        </div>
      </div>

      {!isIncluded ? <div className={styles.PreStartExcludedState}>Excluded from this SWMS</div> : null}
      {serverState.loading ? (
        <div className={styles.PreStartLoadingState}><CircularProgress size={18} /></div>
      ) : null}
      {!serverState.loading && error ? (
        <div className={styles.PreStartErrorState}>
          <div>{error}</div>
          <button type="button" className={styles.PreStartRetryButton} onClick={onRetry}>Retry</button>
        </div>
      ) : null}
      {!serverState.loading && !error && questions.length === 0 ? (
        <div className={styles.PreStartEmptyState}>No emergency readiness questions yet.</div>
      ) : null}
      {!serverState.loading && questions.length > 0 ? (
        <div className={styles.PreStartQuestionsWrap}>
          <JobSwmsV3RescueReadinessQuestionsList
            questions={questions}
            visibleOrders={visibleOrders}
            reorderDisabled={questionInteractionDisabled}
            moveQuestionRow={moveQuestionRow}
            onAfterDropQuestionRow={onAfterDropQuestionRow}
            onOpenEditQuestion={editQuestion}
          />
        </div>
      ) : null}

      <div className={styles.PreStartSaveActionsRow}>
        {requestInFlight ? <CircularProgress size={20} /> : null}
        <button className={commonStyles.OutlinedButton} type="button" disabled={!hasUnsavedQuestionChanges || requestInFlight} onClick={cancel}>
          {Strings.cancel_btn}
        </button>
        <button className={commonStyles.PrimaryButton} type="button" disabled={!hasUnsavedQuestionChanges || requestInFlight} onClick={save}>
          {Strings.save_btn}
        </button>
      </div>
    </div>
  );
}

export default reduxForm({
  form: "JobSwmsV3RescueReadinessContainerForm",
  destroyOnUnmount: true,
  enableReinitialize: true
})(JobSwmsV3RescueReadinessContainer);
